import { render } from "./ExtendedSearch.vue?vue&type=template&id=13a0ffda&scoped=true"
import script from "./ExtendedSearch.vue?vue&type=script&lang=js"
export * from "./ExtendedSearch.vue?vue&type=script&lang=js"

import "./ExtendedSearch.vue?vue&type=style&index=0&id=13a0ffda&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a0ffda"]])

export default __exports__